module.exports = __webpack_public_path__ + "static/media/bg_ss.d7e200ba.png";